import { updateCadImage } from './benchCadImage';
import { buildGlassWall } from '../helpers/glassWallBuilder';
import glassWallPriceStore from '../helpers/glassWallPriceStore';
import { glassPriceUpdated, updateOptionRows } from './optionPricing';
import { getLimits } from '../lib/glassWallComponent.esm'

export const markGlassWallEdited = () => ({ type: 'GLASS_WALL_EDITED' });

export const doorFromLeftUpdated = (doorFromLeft) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DOORFROMLEFT_UPDATED',
            doorFromLeft: parseInt(doorFromLeft)
        });
        dispatch(updateDoorConstraints());
        const shouldInitializeGlassWall = !getState().measurements.glassWallInitialized;
        if (shouldInitializeGlassWall)
            dispatch(restoreDefaultGlassWall());
        else // The initialized glass wall is not being rebuilt, so its CAD image must be refreshed here.
            dispatch(updateCadImage());
    }
};


export const totalWidthChanged = (totalWidth) => {
    return (dispatch, getstate) => {
        let measurements = getstate().measurements;
        
        if (measurements.leftSideGlassEnabled) {
            if (measurements.rightSideGlassEnabled) {
                let change = totalWidth - (measurements.rightSideGlassWidth + measurements.leftSideGlassWidth + measurements.doorWidth);
                dispatch(changeLeftSideGlassWidth(measurements.leftSideGlassWidth + change/2));
                dispatch(changeRightSideGlassWidth(measurements.rightSideGlassWidth + change/2));
            }
            else {
                let change = totalWidth - (measurements.leftSideGlassWidth + measurements.doorWidth);
                dispatch(changeLeftSideGlassWidth(measurements.leftSideGlassWidth + change));
            }
        }
        else if (measurements.rightSideGlassEnabled) {
            let change = totalWidth - (measurements.rightSideGlassWidth + measurements.doorWidth);
            dispatch(changeRightSideGlassWidth(measurements.rightSideGlassWidth + change));
        }
    }
};



export const changeDoorType = (doorType) => {
    return (dispatch, getState) => {
        const shouldInitializeGlassWall = !getState().measurements.glassWallInitialized;
        dispatch({
            type: 'DOOR_TYPE_CHANGED',
            doorType: doorType
        });
        if (doorType == 'customGlassWall' && shouldInitializeGlassWall) {
            let measurements = getState().measurements;
            let defaultValues = buildGlassWall(measurements);
            dispatch(changeLeftSideGlassHeight(defaultValues.leftSideGlassHeight));
            dispatch(changeLeftSideGlassWidth(defaultValues.leftSideGlassWidth));
            if (defaultValues.leftSideGlassEnabled != measurements.leftSideGlassEnabled) dispatch(toggleLeftSideGlass());
            dispatch(changeRightSideGlassHeight(defaultValues.rightSideGlassHeight));
            dispatch(changeRightSideGlassWidth(defaultValues.rightSideGlassWidth));
            if (defaultValues.rightSideGlassEnabled != measurements.rightSideGlassEnabled) dispatch(toggleRightSideGlass());
            dispatch(changeDoorHeight(defaultValues.doorHeight));
            if (defaultValues.upGlassEnabled != measurements.upGlassEnabled) dispatch(toggleUpGlass());
            dispatch(changeUpGlassHeight(defaultValues.upGlassHeight));
        }
        dispatch(updateGlassPrice());
    }
}

export const restoreDefaultGlassWall = () => {
    return (dispatch, getState) => {
        const defaults = buildGlassWall(getState().measurements);
        dispatch({
            type: 'RESTORE_DEFAULT_GLASS_WALL',
            defaults: defaults
        });
        dispatch(updateDoorConstraints());
        dispatch(updateGlassPrice());
        dispatch(updateCadImage());
    };
};

let glassPricesStore = new glassWallPriceStore();

export const updateGlassPrice = () => {
    return (dispatch, getState) => {
        if (getState().clientConfiguration.showPrices) {
            let measurements = getState().measurements;
            let glassType;
            switch (measurements.doorType) {
                case 'customGlassWall':
                    glassType = 1;
                    break;
                case 'doorWithCarms':
                    glassType = 3;
                    break;
                default:
                    glassType = 2;
                    break;
            }
            if (glassType != 2) {
                let glassWall = Object.assign(measurements, { glassWallType: glassType });
                glassPricesStore.getPriceAsync(glassWall).
                    then(price => {
                        dispatch(glassPriceUpdated(price));
                        dispatch(updateOptionRows());
                    });               
            }
            else {
                dispatch(glassPriceUpdated(0));
                dispatch(updateOptionRows());
            }           
        }
    }
}




const updateDoorConstraints = () => {
    return (dispatch, getState) => {
        let measurements = getState().measurements;
        let limits = getLimits(measurements)
        dispatch({
            type: 'UPDATE_DOORSIZE_CONSTRAINTS',
            doorSizeConstraints: limits
        })
        if (limits.leftSideGlassMaxWidth == 0 && measurements.leftSideGlassEnabled) {
            dispatch(toggleLeftSideGlass());
        }
        else if (measurements.leftSideGlassWidth > limits.leftSideGlassMaxWidth) {
            dispatch(changeLeftSideGlassWidth(limits.leftSideGlassMaxWidth));   
        }
        if (measurements.leftSideGlassWidth < limits.leftSideGlassMinWidth) {
            dispatch(changeLeftSideGlassWidth(limits.leftSideGlassMinWidth)); 
        }           

        if (limits.rightSideGlassMaxWidth == 0 && measurements.rightSideGlassEnabled) {
            dispatch(toggleRightSideGlass());
        }
        else if (measurements.rightSideGlassWidth > limits.rightSideGlassMaxWidth) {
            dispatch(changeRightSideGlassWidth(limits.rightSideGlassMaxWidth));
        }
        if (measurements.rightSideGlassWidth < limits.rightSideGlassMinWidth) {
            dispatch(changeRightSideGlassWidth(limits.rightSideGlassMinWidth));
        }
    };
}


export const changeDoorMaterial = (material) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DOORMATERIAL_CHANGED',
            material: material
        });
        dispatch(updateGlassPrice());
    }
}
export const changeGlassListMaterial = (materialId) => {
    return ((dispatch) => {
        dispatch({
            type: 'GLASSLIST_MATERIAL_CHANGED',
            materialId: materialId
        });
        dispatch(updateGlassPrice());
    });
}
export const changeLeftSideGlassHeight = (height) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'LEFTSIDEGLASS_HEIGHT_CHANGED',
            height: height
        });
        dispatch(updateGlassPrice());
    }
}
export const changeLeftSideGlassWidth = (width) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'LEFTSIDEGLASS_WIDTH_CHANGED',
            width: width
        });
        dispatch(updateGlassPrice());
    }
}
export const toggleLeftSideGlass = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TOGGLE_LEFTSIDEGLASS'
        });
        dispatch(updateGlassPrice());
    }
}

export const changeRightSideGlassHeight = (height) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'RIGHTSIDEGLASS_HEIGHT_CHANGED',
            height: height
        });
        dispatch(updateGlassPrice());
    };      
}


export const changeRightSideGlassWidth = (width) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'RIGHTSIDEGLASS_WIDTH_CHANGED',
            width: width
        })
        dispatch(updateGlassPrice());
    };

}
export const toggleRightSideGlass = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'TOGGLE_RIGHTSIDEGLASS'
        })
        dispatch(updateGlassPrice());
    }
}

export const changeSpaceUnderDoor = (height) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SPACE_UNDER_DOOR_CHANGED',
            height:height
        })
        dispatch(updateGlassPrice());
    }
}
export const changeDoorHeight = (height) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DOOR_HEIGHT_CHANGED',
            height: height
        })
        dispatch(updateGlassPrice());
    };
}



export const changeDoorHandness = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_DOOR_HANDNESS'
        })
        dispatch(updateGlassPrice());
    };
}



export const toggleUpGlass = () => {
    return (dispatch, getState) => {
        let measurements = getState().measurements;

        if (measurements.upGlassEnabled) {
            dispatch(changeUpGlassHeight(0));
        }
        else {
            dispatch(changeUpGlassHeight(300));
        }
        dispatch({
            type: 'TOGGLE_UPGLASS'
        })
        dispatch(updateGlassPrice());
    };
}



export const changeUpGlassHeight = (height) => {
    return (dispatch) => {
        dispatch({
            type: 'UP_GLASS_HEIGHT_CHANGED',
            height: height
        });
    };
}



